import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { relatedProductsPopupSelector, popupModeSelector } from '../../../redux/product/product.selectors';
import { relatedProductsPopupDispatcher } from '../../../redux/product/product.dispatchers';
import { RelatedProductsPopupComponent } from './related-products-popup';
const mapStateToProps = createStructuredSelector({
  relatedProducts: relatedProductsPopupSelector,
  popupMode: popupModeSelector
});
export const RelatedProductsPopup = connect(mapStateToProps, relatedProductsPopupDispatcher)(RelatedProductsPopupComponent);